import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

const setHideFavoritesListMutatorMutator: (flag: boolean) => void = mutatorAction(
    'setHideFavoritesList',
    (flag: boolean): void => {
        getStore().hideFavoritesList = flag;
    }
);
export default setHideFavoritesListMutatorMutator;
